import afghanistan from "./icons/flags/afghanistan.svg";
import albania from "./icons/flags/albania.svg";
import algeria from "./icons/flags/algeria.svg";
import andorra from "./icons/flags/andorra.svg";
import angola from "./icons/flags/angola.svg";
import argentina from "./icons/flags/argentina.svg";
import armenia from "./icons/flags/armenia.svg";
import australia from "./icons/flags/australia.svg";
import austria from "./icons/flags/austria.svg";
import azerbaijan from "./icons/flags/azerbaijan.svg";
import bahrain from "./icons/flags/bahrain.svg";
import bangladesh from "./icons/flags/bangladesh.svg";
import belarus from "./icons/flags/belarus.svg";
import belgium from "./icons/flags/belgium.svg";
import belize from "./icons/flags/belize.svg";
import benin from "./icons/flags/benin.svg";
import bhutan from "./icons/flags/bhutan.svg";
import bolivia from "./icons/flags/bolivia.svg";
import bosniaAndHerzegovina from "./icons/flags/bosniaAndHerzegovina.svg";
import botswana from "./icons/flags/botswana.svg";
import brazil from "./icons/flags/brazil.svg";
import brunei from "./icons/flags/brunei.svg";
import bulgaria from "./icons/flags/bulgaria.svg";
import burkinaFaso from "./icons/flags/burkinaFaso.svg";
import burundi from "./icons/flags/burundi.svg";
import cambodia from "./icons/flags/cambodia.svg";
import cameroon from "./icons/flags/cameroon.svg";
import canada from "./icons/flags/canada.svg";
import capeVerde from "./icons/flags/capeVerde.svg";
import centralAfricanRepublic from "./icons/flags/centralAfricanRepublic.svg";
import chad from "./icons/flags/chad.svg";
import chile from "./icons/flags/chile.svg";
import china from "./icons/flags/china.svg";
import colombia from "./icons/flags/colombia.svg";
import costaRica from "./icons/flags/costaRica.svg";
import croatia from "./icons/flags/croatia.svg";
import cuba from "./icons/flags/cuba.svg";
import cyprus from "./icons/flags/cyprus.svg";
import cz from "./icons/flags/cz.svg";
import denmark from "./icons/flags/denmark.svg";
import djibouti from "./icons/flags/djibouti.svg";
import drc from "./icons/flags/drc.svg";
import eastTimor from "./icons/flags/eastTimor.svg";
import ecuador from "./icons/flags/ecuador.svg";
import egypt from "./icons/flags/egypt.svg";
import elSalvador from "./icons/flags/elSalvador.svg";
import equatorialGuinea from "./icons/flags/equatorialGuinea.svg";
import eritrea from "./icons/flags/eritrea.svg";
import estonia from "./icons/flags/estonia.svg";
import ethiopia from "./icons/flags/ethiopia.svg";
import fiji from "./icons/flags/fiji.svg";
import finland from "./icons/flags/finland.svg";
import france from "./icons/flags/france.svg";
import gabon from "./icons/flags/gabon.svg";
import gambia from "./icons/flags/gambia.svg";
import gb from "./icons/flags/gb.svg";
import georgia from "./icons/flags/georgia.svg";
import germany from "./icons/flags/germany.svg";
import ghana from "./icons/flags/ghana.svg";
import gibraltar from "./icons/flags/gibraltar.svg";
import greece from "./icons/flags/greece.svg";
import greenland from "./icons/flags/greenland.svg";
import guatemala from "./icons/flags/guatemala.svg";
import guinea from "./icons/flags/guinea.svg";
import guineaBissau from "./icons/flags/guineaBissau.svg";
import guyana from "./icons/flags/guyana.svg";
import haiti from "./icons/flags/haiti.svg";
import honduras from "./icons/flags/honduras.svg";
import hongKong from "./icons/flags/hongKong.svg";
import hungary from "./icons/flags/hungary.svg";
import iceland from "./icons/flags/iceland.svg";
import india from "./icons/flags/india.svg";
import indonesia from "./icons/flags/indonesia.svg";
import iran from "./icons/flags/iran.svg";
import iraq from "./icons/flags/iraq.svg";
import ireland from "./icons/flags/ireland.svg";
import israel from "./icons/flags/israel.svg";
import italy from "./icons/flags/italy.svg";
import ivoryCoast from "./icons/flags/ivoryCoast.svg";
import japan from "./icons/flags/japan.svg";
import jordan from "./icons/flags/jordan.svg";
import kazakhstan from "./icons/flags/kazakhstan.svg";
import kenya from "./icons/flags/kenya.svg";
import kiribati from "./icons/flags/kiribati.svg";
import kosovo from "./icons/flags/kosovo.svg";
import kuwait from "./icons/flags/kuwait.svg";
import kyrgyzstan from "./icons/flags/kyrgyzstan.svg";
import laos from "./icons/flags/laos.svg";
import latvia from "./icons/flags/latvia.svg";
import lebanon from "./icons/flags/lebanon.svg";
import lesotho from "./icons/flags/lesotho.svg";
import liberia from "./icons/flags/liberia.svg";
import libya from "./icons/flags/libya.svg";
import liechtenstein from "./icons/flags/liechtenstein.svg";
import lithuania from "./icons/flags/lithuania.svg";
import luxembourg from "./icons/flags/luxembourg.svg";
import macau from "./icons/flags/macau.svg";
import macedonia from "./icons/flags/macedonia.svg";
import madagascar from "./icons/flags/madagascar.svg";
import malawi from "./icons/flags/malawi.svg";
import malaysia from "./icons/flags/malaysia.svg";
import maldives from "./icons/flags/maldives.svg";
import mali from "./icons/flags/mali.svg";
import malta from "./icons/flags/malta.svg";
import marshallIsland from "./icons/flags/marshallIsland.svg";
import mauritania from "./icons/flags/mauritania.svg";
import mauritius from "./icons/flags/mauritius.svg";
import mexico from "./icons/flags/mexico.svg";
import micronesia from "./icons/flags/micronesia.svg";
import moldova from "./icons/flags/moldova.svg";
import monaco from "./icons/flags/monaco.svg";
import mongolia from "./icons/flags/mongolia.svg";
import montenegro from "./icons/flags/montenegro.svg";
import morocco from "./icons/flags/morocco.svg";
import mozambique from "./icons/flags/mozambique.svg";
import myanmar from "./icons/flags/myanmar.svg";
import namibia from "./icons/flags/namibia.svg";
import nepal from "./icons/flags/nepal.svg";
import netherlands from "./icons/flags/netherlands.svg";
import newZealand from "./icons/flags/newZealand.svg";
import nicaragua from "./icons/flags/nicaragua.svg";
import niger from "./icons/flags/niger.svg";
import nigeria from "./icons/flags/nigeria.svg";
import northKorea from "./icons/flags/northKorea.svg";
import norway from "./icons/flags/norway.svg";
import oman from "./icons/flags/oman.svg";
import pakistan from "./icons/flags/pakistan.svg";
import palau from "./icons/flags/palau.svg";
import palestine from "./icons/flags/palestine.svg";
import panama from "./icons/flags/panama.svg";
import papuaNewGuinea from "./icons/flags/papuaNewGuinea.svg";
import paraguay from "./icons/flags/paraguay.svg";
import peru from "./icons/flags/peru.svg";
import philippines from "./icons/flags/philippines.svg";
import poland from "./icons/flags/poland.svg";
import portugal from "./icons/flags/portugal.svg";
import qatar from "./icons/flags/qatar.svg";
import romania from "./icons/flags/romania.svg";
import rpc from "./icons/flags/rpc.svg";
import russia from "./icons/flags/russia.svg";
import rwanda from "./icons/flags/rwanda.svg";
import samoa from "./icons/flags/samoa.svg";
import sanMarino from "./icons/flags/sanMarino.svg";
import saoTomeAndPrince from "./icons/flags/saoTomeAndPrince.svg";
import saudiArabia from "./icons/flags/saudiArabia.svg";
import senegal from "./icons/flags/senegal.svg";
import serbia from "./icons/flags/serbia.svg";
import seychelles from "./icons/flags/seychelles.svg";
import sierraLeone from "./icons/flags/sierraLeone.svg";
import singapore from "./icons/flags/singapore.svg";
import slovakia from "./icons/flags/slovakia.svg";
import slovenia from "./icons/flags/slovenia.svg";
import solomonIslands from "./icons/flags/solomonIslands.svg";
import somalia from "./icons/flags/somalia.svg";
import southAfrica from "./icons/flags/southAfrica.svg";
import southKorea from "./icons/flags/southKorea.svg";
import southSudan from "./icons/flags/southSudan.svg";
import spain from "./icons/flags/spain.svg";
import sriLanka from "./icons/flags/sriLanka.svg";
import sudan from "./icons/flags/sudan.svg";
import suriname from "./icons/flags/suriname.svg";
import swaziland from "./icons/flags/swaziland.svg";
import sweden from "./icons/flags/sweden.svg";
import switzerland from "./icons/flags/switzerland.svg";
import syria from "./icons/flags/syria.svg";
import taiwan from "./icons/flags/taiwan.svg";
import tajikistan from "./icons/flags/tajikistan.svg";
import tanzania from "./icons/flags/tanzania.svg";
import thailand from "./icons/flags/thailand.svg";
import togo from "./icons/flags/togo.svg";
import tonga from "./icons/flags/tonga.svg";
import tunisia from "./icons/flags/tunisia.svg";
import turkey from "./icons/flags/turkey.svg";
import turkmenistan from "./icons/flags/turkmenistan.svg";
import tuvalu from "./icons/flags/tuvalu.svg";
import uae from "./icons/flags/uae.svg";
import uganda from "./icons/flags/uganda.svg";
import ukraine from "./icons/flags/ukraine.svg";
import uruguay from "./icons/flags/uruguay.svg";
import us from "./icons/flags/us.svg";
import uzbekistan from "./icons/flags/uzbekistan.svg";
import vanuatu from "./icons/flags/vanuatu.svg";
import venezuela from "./icons/flags/venezuela.svg";
import vietnam from "./icons/flags/vietnam.svg";
import yemen from "./icons/flags/yemen.svg";
import zambia from "./icons/flags/zambia.svg";
import zimbabwe from "./icons/flags/zimbabwe.svg";

export const flags: Record<string, string> = {
  afghanistan,
  albania,
  algeria,
  andorra,
  angola,
  argentina,
  armenia,
  australia,
  austria,
  azerbaijan,
  bahrain,
  bangladesh,
  belarus,
  belgium,
  belize,
  benin,
  bhutan,
  bolivia,
  bosniaAndHerzegovina,
  botswana,
  brazil,
  brunei,
  bulgaria,
  burkinaFaso,
  burundi,
  cambodia,
  cameroon,
  canada,
  capeVerde,
  centralAfricanRepublic,
  chad,
  chile,
  china,
  colombia,
  costaRica,
  croatia,
  cuba,
  cyprus,
  cz,
  denmark,
  djibouti,
  drc,
  eastTimor,
  ecuador,
  egypt,
  elSalvador,
  equatorialGuinea,
  eritrea,
  estonia,
  ethiopia,
  fiji,
  finland,
  france,
  gabon,
  gambia,
  gb,
  georgia,
  germany,
  ghana,
  gibraltar,
  greece,
  greenland,
  guatemala,
  guinea,
  guineaBissau,
  guyana,
  haiti,
  honduras,
  hongKong,
  hungary,
  iceland,
  india,
  indonesia,
  iran,
  iraq,
  ireland,
  israel,
  italy,
  ivoryCoast,
  japan,
  jordan,
  kazakhstan,
  kenya,
  kiribati,
  kosovo,
  kuwait,
  kyrgyzstan,
  laos,
  latvia,
  lebanon,
  lesotho,
  liberia,
  libya,
  liechtenstein,
  lithuania,
  luxembourg,
  macau,
  macedonia,
  madagascar,
  malawi,
  malaysia,
  maldives,
  mali,
  malta,
  marshallIsland,
  mauritania,
  mauritius,
  mexico,
  micronesia,
  moldova,
  monaco,
  mongolia,
  montenegro,
  morocco,
  mozambique,
  myanmar,
  namibia,
  nepal,
  netherlands,
  newZealand,
  nicaragua,
  niger,
  nigeria,
  northKorea,
  norway,
  oman,
  pakistan,
  palau,
  palestine,
  panama,
  papuaNewGuinea,
  paraguay,
  peru,
  philippines,
  poland,
  portugal,
  qatar,
  romania,
  rpc,
  russia,
  rwanda,
  samoa,
  sanMarino,
  saoTomeAndPrince,
  saudiArabia,
  senegal,
  serbia,
  seychelles,
  sierraLeone,
  singapore,
  slovakia,
  slovenia,
  solomonIslands,
  somalia,
  southAfrica,
  southKorea,
  southSudan,
  spain,
  sriLanka,
  sudan,
  suriname,
  swaziland,
  sweden,
  switzerland,
  syria,
  taiwan,
  tajikistan,
  tanzania,
  thailand,
  togo,
  tonga,
  tunisia,
  turkey,
  turkmenistan,
  tuvalu,
  uae,
  uganda,
  ukraine,
  uruguay,
  us,
  uzbekistan,
  vanuatu,
  venezuela,
  vietnam,
  yemen,
  zambia,
  zimbabwe,
};

export const flagCountryCodes = Object.keys(flags);
